import { createSelector } from "@ngrx/store";

import * as fromRoot from "../../../router-store";
import * as fromFeature from "../reducers";
import * as fromAssignments from "#core/teacher-classes/store/reducers/assignments.reducer";
import * as selectorsHelperFn from "#helpers/selectors.helper";
import { PPAssignment as Assignment } from "cli-types";

// get assignment state
export const getAssignmentsState = createSelector(
    fromFeature.getCoursesModuleState,
    (state: fromFeature.CoursesState) => state.assignments
);

// get assignment entities
export const getAssignmentsEntities = createSelector(
    getAssignmentsState,
    fromAssignments.getAssignmentsEntities
);

// get individual assignment
export const getSelectedAssignment = createSelector(
    getAssignmentsEntities,
    fromRoot.getRouterState,
    (entities, router): Assignment | null => {
        return selectorsHelperFn.getSelectedEntity<Assignment>(
            entities,
            router,
            "assignmentID"
        );
    }
);

// convert Entities so view can consume
export const getAllAssignments = createSelector(
    getAssignmentsEntities,
    (entities) => {
        return Array.from(entities.values());
    }
);

// get current(selected) assignment from teacher-class/student profile
export const getCurrentStudentProfileAssignment = createSelector(
    getAssignmentsState,
    fromAssignments.getCurrentStudentProfileAssignment
);

export const getEvalAssignmentsLoading = createSelector(
    getAssignmentsState,
    fromAssignments.getEvalAssignmentsLoading
);

export const getEvalAssignmentsLoaded = createSelector(
    getAssignmentsState,
    fromAssignments.getEvalAssignmentsLoaded
);

export const getNeedsEvalAssignmentsLoading = createSelector(
    getAssignmentsState,
    fromAssignments.getNeedsEvalAssignmentsLoading
);

export const getNeedsEvalAssignmentsLoaded = createSelector(
    getAssignmentsState,
    fromAssignments.getNeedsEvalAssignmentsLoaded
);

export const getRawAssignmentResponse = createSelector(
    getAssignmentsState,
    fromAssignments.getRawResponse
);

export const getStudentAssignmentPaginationParams = createSelector(
    getAssignmentsState,
    fromAssignments.getStudentPaginationParams
);

export const getCourseAssignmentPaginationParams = createSelector(
    getAssignmentsState,
    fromAssignments.getCoursePaginationParams
);

export const getCourseAssignmentsFilterBoxOpened = createSelector(
    getAssignmentsState,
    fromAssignments.getCourseAssignmentsFilterBoxOpened
);
export const getStudentAssignmentsFilterBoxOpened = createSelector(
    getAssignmentsState,
    fromAssignments.getStudentAssignmentsFilterBoxOpened
);
